const ParticipantsComponents = {
    PARTICIPANTS: "participants",
};

export default ParticipantsComponents;
